<template>
  <div>
    <button @click="show = true">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4 text-gray-600 inline-flex"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
        />
      </svg>
    </button>

    <Portal v-if="show" to="app-dialog">
      <EmailAddressesPropertyEditModal
        :contact-id="contactId"
        :primary-email-address="primaryEmailAddress"
        :email-addresses="emailAddresses"
        :on-refresh-contact="fetchContact"
        @close="show = false"
      />
    </Portal>
  </div>
</template>

<script>
import EmailAddressesPropertyEditModal from './EmailAddressesPropertyEditModal.vue';

export default {
  components: {
    EmailAddressesPropertyEditModal,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.contactId] || null;
    },
    primaryEmailAddress() {
      const primaryEmailAddrssId = this.contact?.primaryEmailAddressId;
      if (!primaryEmailAddrssId) {
        return null;
      }

      return this.$store.state.entities.emailAddresses.byId[primaryEmailAddrssId] || null;
    },
    emailAddresses() {
      const emailAddressIds = this.contact?.emailAddresses;

      if (!emailAddressIds) {
        return [];
      }

      return emailAddressIds.map(
        (emailAddressId) => this.$store.state.entities.emailAddresses.byId[emailAddressId]
      );
    },
  },
  inject: ['fetchContact'],
};
</script>
